import { Box, styled, Divider } from '@mui/material'
import IconCommon from 'assets/icon/IconCommon'
import { colors } from 'constants/theme'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { dateMonthToView, timeToView } from 'utils/date.utils'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import moment from 'moment'


type pdfThermalTH = {
    branchInfo: any
    appointment: any
    user: any

}

const PDFThermalTH = (props: pdfThermalTH) => {
    const { branchInfo, appointment, user } = props
    const { t } = useTranslation()

    return (
        <Box  >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '16px',
                    paddingBottom: '16px',
                    img: { height: 100, width: 'auto' }
                }}
            >
                {branchInfo?.branchLogo && (
                    <img src={branchInfo.branchLogo} alt="logo" />
                )}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    marginLeft: '10px',
                    marginRight: '10px'
                }}
            >
                <Box mb={1}>
                    <Box fontSize="16px" fontWeight="bold">
                        {branchInfo?.clinicName ?? ''}
                    </Box>
                    <Box fontSize="12px" color="black">
                        {branchInfo?.branchName ?? ''}
                    </Box>
                </Box>
                <Box>
                    <Box fontSize="12px" color="black">
                        {branchInfo?.branchFullAddress ?? ''}
                    </Box>
                    <Box fontSize="12px" color="black">
                        {`${t('APPOINTMENT.PDF.WEB')}: ${branchInfo?.branchWebsite ?? ''} / ${t('APPOINTMENT.PDF.EMAIL_EN')}: ${branchInfo?.branchEmail ?? ''}`}
                    </Box>
                    <Box fontSize="12px" color="black">
                        {`${t('APPOINTMENT.PDF.TEL')}: ${branchInfo?.branchPhone1 ?? ''} ${t('APPOINTMENT.PDF.LINE_EN')}@: ${branchInfo?.branchLine ?? ''}`}
                    </Box>
                </Box>
            </Box>
            <Box marginLeft='10px' marginRight='10px'>
                <Box
                    whiteSpace="nowrap"
                    fontSize="16px"
                    paddingY='10px'
                    fontWeight="bold"
                    textAlign="center"
                    justifyContent="center"
                    color="black"
                >
                    {t('APPOINTMENT.PDF.APPOINTMENT_CARD')}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box component="span" fontWeight="bold">
                        {t('APPOINTMENT.PDF.APPOINTMENT_NUMBER')}:
                    </Box>{' '}
                    {appointment?.appointmentNumber ?? ''}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.PATIENT_CN_NUMBER')}:{' '}
                    </Box>
                    {appointment?.cnNumber ?? ''}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.PATIENT_NAME')}:{' '}
                    </Box>
                    {`${appointment?.prefixName ?? ''} ${appointment?.patientFullname ?? ''}`}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.DATE')}:{' '}
                    </Box>
                    {appointment?.date ? dateMonthToView(appointment.date, true, 'th') : ''}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.TIME')}:{' '}
                    </Box>
                    {`${appointment?.timeStart?.substring(0, 5)} ${t('APPOINTMENT.PDF.TIME_UNIT')}`}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.DOCTOR_NAME')}:{' '}
                    </Box>
                    {appointment?.doctorFullname ?? ''}
                </Box>

                <Box whiteSpace="nowrap" fontSize="12px" color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.TREATMENT')}:
                    </Box>
                </Box>

                <Box marginBottom="10px">
                    {appointment?.appointmentOperatives?.map((item: any, index: any) => (
                        <Box key={index} fontSize={12} color="black">
                            <FiberManualRecordIcon
                                sx={{ width: 5, height: 5, mr: 1, ml: 1, color: 'black' }}
                            />
                            {item?.operativeName || item?.operativeTypeName}
                        </Box>
                    ))}
                </Box>

                <Divider
                    sx={{
                        margin: '0 !important',
                        borderColor: '#b8b8b8 !important',
                        height: '1px !important'
                    }}
                />

                <Box display="flex" marginBottom="8px" marginTop="8px" flexDirection="column">
                    <Box whiteSpace="nowrap" fontSize="12px" color="black">
                        <Box
                            component="span"
                            sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                        >
                            {t('APPOINTMENT.PDF.AUTH')}:{' '}
                        </Box>
                        {user?.fullname ?? ''}
                    </Box>
                    <Box whiteSpace="nowrap" fontSize="12px" color="black">
                        <Box
                            component="span"
                            sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                        >
                            {t('APPOINTMENT.PDF.AUTH_DATE')}:{' '}
                        </Box>
                        {`${dateMonthToView(moment(), true, 'th')}  (${timeToView()} ${t('APPOINTMENT.PDF.TIME_UNIT')})`}
                    </Box>
                </Box>
            </Box>
        </Box >
    )
}

export default PDFThermalTH